import { render, staticRenderFns } from "./add-exams.vue?vue&type=template&id=17f28aaa&scoped=true&"
import script from "./add-exams.vue?vue&type=script&lang=js&"
export * from "./add-exams.vue?vue&type=script&lang=js&"
import style0 from "./add-exams.vue?vue&type=style&index=0&id=17f28aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f28aaa",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex})
